import GamesCategoryPage from "../pages/User/Games/GamesCategoryPage";

// ICONS GAME CATEGORY
import { ReactComponent as IconLobby } from "../assets/icons/icon-lobby.svg";
import { ReactComponent as IconTopGames } from "../assets/icons/icon-top-games.svg";
import { ReactComponent as IconFeatured } from "../assets/icons/icon-featured.svg";
import { ReactComponent as IconNew } from "../assets/icons/icon-new.svg";
import { ReactComponent as IconSlots } from "../assets/icons/icon-slots.svg";
import { ReactComponent as IconCrash } from "../assets/icons/icon-crash.svg";
import { ReactComponent as IconProviders } from "../assets/icons/icon-providers.svg";
import { ReactComponent as IconLiveCasino } from "../assets/icons/icon-live-casino.svg";
import { ReactComponent as IconAmatic } from "../assets/icons/icon-amatic.svg";
import { ReactComponent as IconPragmatic } from "../assets/icons/icon-pragmatic.svg";
import { ReactComponent as Icon7777Gaming } from "../assets/icons/icon-7777-gaming.svg";
import { ReactComponent as IconUpGaming } from "../assets/icons/icon-up-gaming.svg";
import { ReactComponent as IconOtherGames } from "../assets/icons/icon-other-games.svg";

// ICONS USER MENU
import { ReactComponent as IconMyAccount } from "../assets/icons/icon-my-account.svg";
import { ReactComponent as IconCasinoBetsWhite } from "../assets/icons/icon-casino-bets-white.svg";
import { ReactComponent as IconSportbookBetsWhite } from "../assets/icons/icon-sportsbook-bets-white.svg";
import { ReactComponent as IconTransactionsHistory } from "../assets/icons/icon-transactions-history.svg";
import { ReactComponent as IconVerifyAccount } from "../assets/icons/icon-verify-account.svg";

// ICONS SIDEBAR
import { ReactComponent as IconTransfer } from "../assets/icons/icon-transfer.svg";
import { ReactComponent as IconTransferHistory } from "../assets/icons/icon-transfer-history.svg";
import { ReactComponent as IconTransferReport } from "../assets/icons/icon-transfer-report.svg";
import { ReactComponent as IconGamingReport } from "../assets/icons/icon-gaming-report.svg";
import { ReactComponent as IconSportbookBets } from "../assets/icons/icon-sportsbook-bets.svg";
import { ReactComponent as IconCasinoBets } from "../assets/icons/icon-casino-bets.svg";
import { ReactComponent as IconManageUsers } from "../assets/icons/icon-manage-users.svg";
import { ReactComponent as IconRegisterUser } from "../assets/icons/icon-register-user.svg";

import TransferForm from "../pages/Admin/transfer/TransferForm";
import TransferHistory from "../pages/Admin/transfer/TransferHistory";
import TransferReport from "../pages/Admin/transfer/TransferReport";
import GamingReport from "../pages/Admin/GamingReport";
import CasinoBets from "../pages/Admin/CasinoBet";
import ManageUser from "../pages/Admin/ManageUser";
import RegisterForm from "../pages/Admin/RegisterUser";
import SportBetBook from "../pages/Admin/SportBetBook";
import { FaHistory, FaKey, FaListAlt, FaMoneyBill, FaSignInAlt, FaSignOutAlt, FaUserCircle } from "react-icons/fa";
import { useTranslation } from "react-i18next";

export const GAMES_CATEGORY_NAV = () => {
  const { t } = useTranslation();
  return [
    // {
    //   label: t("Lobby"),
    //   path: "/lobby",
    //   component: <GamesCategoryPage />,
    //   icon: <IconLobby />,
    //   visible: false,
    // },
    // {
    //   label: t("Casino"),
    //   path: "/casino",
    //   component: <GamesCategoryPage />,
    //   category: "",
    //   icon: <IconFeatured />,
    //   visible: false,
    // },

    {
      label: t("Slots"),
      path: "/casino/slots",
      component: <GamesCategoryPage />,
      type: ["video-slots", "cpy-games"],
      icon: <IconSlots />,
      // topGames: ["97033", "98967", "80693", "78247", "80877", "98267", "64951", "94141", "80657", "77071"],
    },
    {
      label: t("Pragmatic Play"),
      path: "/casino/pragmatic",
      component: <GamesCategoryPage />,
      type: "cpygames",
      icon: <IconPragmatic />,
    },
    {
      label: t("Top Games"),
      path: "/casino/top-games",
      component: <GamesCategoryPage />,
      new: true,
      icon: <IconTopGames />,
    },
    {
      label: t("Live Casino"),
      path: "/livecasino",
      component: <GamesCategoryPage />,
      type: "",
      icon: <IconLiveCasino />,
      visible: false,
      topGames: ["22797", "57039", "70735", "81793", "20975", "58937", "87033", "13685", "78191", "86073", "57039", "20975"],
    },

    // {
    //   label: "Cpy Games",
    //   path: "/cpygames",
    //   component: <GamesCategoryPage />,
    //   type: "cpygames",
    //   icon: <IconLiveCasino />,
    // },

    {
      label: t("Upgaming"),
      path: "/casino/upgaming",
      component: <GamesCategoryPage />,
      provider: "UpGaming",
      icon: <IconUpGaming />,
    },

    // {
    //   label: "Providers",
    //   path: "/providers",
    //   component: <GamesCategoryPage />,
    //   category: "pragmatic play",
    //   icon: <IconProviders />,
    //   hideOnLobby: true,
    // },

    {
      label: "Amatic",
      path: "/casino/amatic",
      component: <GamesCategoryPage />,
      category: "Real Dealer Studios",
      icon: <IconAmatic />,
    },

    {
      label: "Other Games",
      path: "/casino/other-games",
      component: <GamesCategoryPage />,
      type: "virtual-games",
      icon: <IconOtherGames />,
    },
  ];
};

export const SPORTS_NAV = () => {
  const { t } = useTranslation();
  return [
    {
      path: "/sportsbook/sports",
      label: t("Prelive Events"),
    },
    {
      path: "/sportsbook/live",
      label: t("Live Events"),
    },
    {
      path: "/sportsbook/sports",
      label: t("Soccer"),
    },
    {
      path: "/sportsbook/sports",
      label: t("Basketball"),
    },
    {
      path: "/sportsbook/sports",
      label: t("Tennis"),
    },
  ];
};

export const USER_NAV = () => {
  const { t } = useTranslation();
  return [
    { icon: <FaUserCircle />, path: "my-account", label: t("My account") },
    { icon: <FaSignInAlt />, path: "deposit", label: t("Deposit") },
    { icon: <FaSignOutAlt />, path: "withdraw", label: t("Withdraw") },
    // { icon: <FaMoneyBill />, path: "my-bonuses", label: t("My Bonuses") },
    { icon: <FaKey />, path: "change-password", label: t("Change Password") },
    { icon: <FaListAlt />, path: "transaction-history", label: t("Transactions") },
    { icon: <FaHistory />, path: "casino-history", label: t("Casino History") },
  ];
};

export const ADMIN_NAV = () => {
  const { t } = useTranslation();
  return [
    {
      title: t("Transfer"),
      path: "/transfer",
      component: <TransferForm />,
      image: <IconTransfer />,
    },
    {
      title: t("Transfer History"),
      path: "/transfer-history",
      component: <TransferHistory />,
      image: <IconTransferHistory />,
    },
    {
      title: t("Transfers Report"),
      path: "/transfers-report",
      component: <TransferReport />,
      image: <IconTransferReport />,
    },
    {
      title: t("Gaming Report"),
      path: "/gaming-report",
      component: <GamingReport />,
      image: <IconGamingReport />,
    },
    {
      title: t("Sportsbook Bets"),
      path: "/sportsbook-bets",
      component: <SportBetBook />,
      image: <IconSportbookBets />,
    },
    {
      title: t("Casino Bets"),
      path: "/casino-bets",
      component: <CasinoBets />,
      image: <IconCasinoBets />,
    },
    {
      title: t("Manage Users"),
      path: "/manage-users",
      component: <ManageUser />,
      image: <IconManageUsers />,
    },
    {
      title: t("Register User"),
      path: "/register-user",
      component: <RegisterForm />,
      image: <IconRegisterUser />,
    },
    // {
    //   title: "Logout",
    //   path: "/home",
    //   image: <IconLogout/>,
    // },
  ];
};
